<template>
  <div ref="layout">
    <create-invoice
      v-show="activeName === 'create'"
      ref="createInvoice"
      :workbench-list="workbenchList"
      @changeActive="changeActive"
    />

    <checke-order
      v-show="activeName === 'checkeOrder'"
      ref="checkeOrder"
      :inf-type="inf_type"
      @changeActive="changeActive"
    />

    <entry-invoice
      v-if="activeName === 'entry'"
      :select-data="checkedData"
      :from-page="fromPage"
      @edit-workbench="delWorkbench"
      @changeActive="changeActive"
    />
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import CheckeOrder from './components/CheckeOrder.vue'
import CreateInvoice from './components/CreateInvoice.vue'
import EntryInvoice from './components/EntryInvoice.vue'
export default {
  components: { CreateInvoice, CheckeOrder, EntryInvoice },
  data() {
    return {
      activeName: 'create',
      fromPage: '',
      orderId: '',
      inf_type: '',
      workbenchList: [],
      checkedData: {}
    }
  },
  watch: {
    activeName(val, oldVal) {
      this.fromPage = oldVal
      // 如果是从确认制票中返回订单选择，需要刷新页面数据
      if (val === 'checkeOrder' && oldVal === 'entry') {
        this.$refs['checkeOrder'].queryData()
      }
    }
  },
  created() {
    // if (this.$route.query.id) {
    //   this.orderId = this.$route.query.id
    //   this.activeName = 'entry'
    // }
  },
  methods: {
    delWorkbench(invo_infoid) {
      this.workbenchList[this.checkedData._index].invo_infoid = invo_infoid
    },
    changeActive(name, inf_type, data, checkedData) {
      inf_type && (this.inf_type = inf_type)
      checkedData && (this.checkedData = checkedData)
      if (data) {
        this.workbenchList = data
        this.workbenchList.forEach((v, i) => (v._index = i))
      }
      this.activeName = name
    },
    deleteWorkbench() {},
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
  padding: 0 20px 20px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/makeInvoice.vue